export const VALUE_FORMATS = {
  // Percentages sometimes have the % symbol included depending on the renderer,
  // so they aren't strictly a number format.
  PERCENT: "percent",
  // Our percentages are provided by the API as a value between 0 - 1, but
  // we sometimes multiply this by 100 to display percentages between 0 - 100 in the application.
  // However, we don't want to multiply by 100 again for the download format.
  PERCENT_100: "percent100",
  NUMBER: "number",
  STRING: "string",
  CURRENCY: "currency",
}

export const ASSET_METRIC_IDS = [
  "marketValue",
  "percentEquity",
  "totalReturn",
  "specificReturn",
  "factorsReturn",
  "tradingReturn",
  "riskTotalContribution",
  "riskSpecificContribution",
  "riskFactorsContribution",
  "predictedBeta",
  "historicalBeta",
  "dynamicPredictedBeta",
]

export const METRICS = {
  PERFORMANCE: "performance",
  RISK: "risk",
  EXPOSURE: "exposure",
  BETA: "beta",
}

export const FACTOR_VIEWS = {
  ALL: "op_all",
}

export const METRIC_TYPES = {
  NET_CONTRIBUTION: "netContribution",
  Z_SCORE: "assetZScore",
  CURRENCY_EXPOSURE: "currencyExposure",
  CURRENCY_PERFORMANCE: "currencyPerformance",
  RISK_DECOMPOSITION: "riskDecomposition",
  STANDALONE: "standalone",
  CUMULATIVE_PERCENT: "cumulativePercent",
}

export const RESIDUAL_RETURN = "residualReturn"

export const INTRADAY_METRIC_CATEGORY = {
  id: "intraday",
  label: "Intraday Metrics",
  description: "Uses the latest available intraday market data. These columns may not follow the dashboard date range when viewing historical periods.",
  items: [
    {
      id: "standalone",
      label: "Standalone Returns",
      category: "Intraday",
      excludeGroupIdFromChildMetricPaths: true,
      items: [
        {
          id: "standaloneReturn1d",
          label: "Today Return",
          category: "Intraday",
          dataPath: "intradayStandalone1d.returnPercent",
          format: VALUE_FORMATS.PERCENT,
          singleFactor: true,
          tooltipMetricType: "Intraday Standalone Performance 1D",
        },
        {
          id: "standaloneReturn5d",
          label: "5 Day Return (to Today)",
          category: "Intraday",
          dataPath: "intradayStandalone5d.returnPercent",
          format: VALUE_FORMATS.PERCENT,
          singleFactor: true,
          tooltipMetricType: "Intraday Standalone Performance 5D",
        },
        {
          id: "standaloneReturn1m",
          label: "1 Month Return (to Today)",
          category: "Intraday",
          dataPath: "intradayStandalone1m.returnPercent",
          format: VALUE_FORMATS.PERCENT,
          singleFactor: true,
          tooltipMetricType: "Intraday Standalone Performance 1M",
        },
      ],
    },
    {
      id: "contribution",
      label: "Portfolio Contribution",
      category: "Intraday",
      excludeGroupIdFromChildMetricPaths: true,
      items: [
        {
          id: "contributionPercent1d",
          label: "Today Contribution",
          category: "Intraday",
          dataPath: "intradayContribution1d.contributionPercent",
          format: VALUE_FORMATS.PERCENT,
          singleFactor: true,
          tooltipMetricType: "Intraday Contribution Performance 1D",
        },
        {
          id: "contributionPercent5d",
          label: "5 Day Contribution (to Today)",
          category: "Intraday",
          dataPath: "intradayContribution5d.contributionPercent",
          format: VALUE_FORMATS.PERCENT,
          singleFactor: true,
          tooltipMetricType: "Intraday Contribution Performance 5D",
        },
        {
          id: "contributionPercent1m",
          label: "1 Month Contribution (to Today)",
          category: "Intraday",
          dataPath: "intradayContribution1m.contributionPercent",
          format: VALUE_FORMATS.PERCENT,
          singleFactor: true,
          tooltipMetricType: "Intraday Contribution Performance 1M",
        },
      ],
    },
    {
      id: "securityPricing",
      label: "Security Pricing",
      category: "Intraday",
      excludeGroupIdFromChildMetricPaths: true,
      items: [
        {
          id: "prices",
          label: "Current Price",
          category: "Intraday",
          dataPath: "intraday.price",
          format: VALUE_FORMATS.CURRENCY,
          singleFactor: true,
        },
        {
          id: "percentChange",
          label: "Price Change",
          category: "Intraday",
          dataPath: "intraday.change_percent",
          format: VALUE_FORMATS.PERCENT_100,
          singleFactor: true,
        },
      ],
    },
  ],
}

export const PERFORMANCE_CONTRIBUTION_CATEGORY_CURRENCY = "$ Performance Contribution"
export const PERFORMANCE_CONTRIBUTION_CATEGORY_PERCENT = "% Performance Contribution"
